"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useRef } from "react";
import { useRouter } from "next/navigation";
import { BrainView } from "../BrainMobile";
import type { ApiWave } from "@/generated/models/ApiWave";
import MyStreamWaveTabsLeaderboard from "../my-stream/MyStreamWaveTabsLeaderboard";
import { useLayout } from "../my-stream/layout/LayoutContext";
import { useWave } from "@/hooks/useWave";
import { ArrowLeftIcon } from "@heroicons/react/24/solid";
import { useUnreadIndicator } from "@/hooks/useUnreadIndicator";
import { useUnreadNotifications } from "@/hooks/useUnreadNotifications";
import { useAuth } from "@/components/auth/Auth";
import { getWaveHomeRoute } from "../../../helpers/navigation.helpers";
interface BrainMobileTabsProps {
  readonly activeView: BrainView;
  readonly onViewChange: (view: BrainView) => void;
  readonly wave?: ApiWave | undefined;
  readonly waveActive: boolean;
  readonly showWavesTab: boolean;
  readonly showStreamBack: boolean;
  readonly isApp?: boolean | undefined;
}
const BrainMobileTabs: React.FC<BrainMobileTabsProps> = t0 => {
  const $ = _c(73);
  const {
    activeView,
    onViewChange,
    wave,
    waveActive,
    showWavesTab,
    showStreamBack,
    isApp
  } = t0;
  const router = useRouter();
  const {
    registerRef
  } = useLayout();
  const {
    connectedProfile
  } = useAuth();
  const mobileTabsRef = useRef(null);
  let t1;
  if ($[0] !== registerRef) {
    t1 = element => {
      mobileTabsRef.current = element;
      registerRef("mobileTabs", element);
    };
    $[0] = registerRef;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const setMobileTabsRef = t1;
  const {
    isMemesWave,
    isRankWave
  } = useWave(wave);
  const t2 = connectedProfile?.handle ?? null;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      type: "messages",
      handle: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    hasUnread: hasUnreadMessages
  } = useUnreadIndicator(t3);
  const {
    haveUnreadNotifications
  } = useUnreadNotifications(connectedProfile?.handle ?? null);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      [BrainView.DEFAULT]: null,
      [BrainView.ABOUT]: null,
      [BrainView.LEADERBOARD]: null,
      [BrainView.WINNERS]: null,
      [BrainView.OUTCOME]: null,
      [BrainView.MY_VOTES]: null,
      [BrainView.FAQ]: null,
      [BrainView.WAVES]: null,
      [BrainView.MESSAGES]: null,
      [BrainView.NOTIFICATIONS]: null
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const tabRefs = useRef(t4);
  let t5;
  let t6;
  if ($[5] !== activeView) {
    t5 = () => {
      const activeTabEl = tabRefs.current[activeView];
      if (activeTabEl) {
        activeTabEl.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest"
        });
      }
    };
    t6 = [activeView];
    $[5] = activeView;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  React.useEffect(t5, t6);
  const aboutButtonClasses = `tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-2 tw-py-1.5 tw-gap-1 tw-flex-1  tw-rounded-md ${activeView === BrainView.ABOUT ? "tw-bg-iron-800" : "tw-bg-iron-950"}`;
  const aboutButtonTextClasses = `tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap ${activeView === BrainView.ABOUT ? "tw-text-iron-300" : "tw-text-iron-400"}`;
  const outcomeButtonClasses = `tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-2 tw-py-1.5 tw-gap-1 tw-flex-1  tw-rounded-md ${activeView === BrainView.OUTCOME ? "tw-bg-iron-800" : "tw-bg-iron-950"}`;
  const otucomeButtonTextClasses = `tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap ${activeView === BrainView.OUTCOME ? "tw-text-iron-300" : "tw-text-iron-400"}`;
  const myVotesButtonClasses = `tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-2 tw-py-1.5 tw-gap-1 tw-flex-1  tw-rounded-md ${activeView === BrainView.MY_VOTES ? "tw-bg-iron-800" : "tw-bg-iron-950"}`;
  const myVotesButtonTextClasses = `tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap ${activeView === BrainView.MY_VOTES ? "tw-text-iron-300" : "tw-text-iron-400"}`;
  const chatButtonClasses = `tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-2 tw-py-1.5 tw-gap-1 tw-flex-1  tw-rounded-md ${activeView === BrainView.DEFAULT ? "tw-bg-iron-800" : "tw-bg-iron-950"}`;
  const chatButtonTextClasses = `tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap ${activeView === BrainView.DEFAULT ? "tw-text-iron-300" : "tw-text-iron-400"}`;
  const wavesButtonClasses = `tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-2 tw-py-1.5 tw-gap-1 tw-flex-1  tw-rounded-md ${activeView === BrainView.WAVES ? "tw-bg-iron-800" : "tw-bg-iron-950"}`;
  const wavesButtonTextClasses = `tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap ${activeView === BrainView.WAVES ? "tw-text-iron-300" : "tw-text-iron-400"}`;
  const messagesButtonClasses = `tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-2 tw-py-1.5 tw-gap-1 tw-flex-1 tw-rounded-md ${activeView === BrainView.MESSAGES ? "tw-bg-iron-800" : "tw-bg-iron-950"}`;
  const messagesButtonTextClasses = `tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap tw-relative ${activeView === BrainView.MESSAGES ? "tw-text-iron-300" : "tw-text-iron-400"}`;
  const notificationsButtonClasses = `tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-2 tw-py-1.5 tw-gap-1 tw-flex-1 tw-rounded-md ${activeView === BrainView.NOTIFICATIONS ? "tw-bg-iron-800" : "tw-bg-iron-950"}`;
  const notificationsButtonTextClasses = `tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap tw-relative ${activeView === BrainView.NOTIFICATIONS ? "tw-text-iron-300" : "tw-text-iron-400"}`;
  let t7;
  if ($[8] !== onViewChange) {
    t7 = () => {
      onViewChange(BrainView.DEFAULT);
    };
    $[8] = onViewChange;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const onChatClick = t7;
  let t8;
  if ($[10] !== onViewChange) {
    t8 = () => {
      onViewChange(BrainView.NOTIFICATIONS);
    };
    $[10] = onViewChange;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const onNotificationsClick = t8;
  let t9;
  if ($[12] !== isApp || $[13] !== onViewChange || $[14] !== router || $[15] !== showStreamBack || $[16] !== waveActive) {
    t9 = waveActive && showStreamBack && !isApp && <><button onClick={() => {
        router.push(getWaveHomeRoute({
          isDirectMessage: false,
          isApp: !!isApp
        }));
        onViewChange(BrainView.DEFAULT);
      }} className="tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-2 tw-py-1.5  tw-gap-1 tw-flex-1 tw-rounded-md tw-bg-iron-950"><ArrowLeftIcon className="tw-size-4 tw-text-iron-400" /><span className="tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap tw-text-iron-400">My Stream</span></button><div className="tw-h-4 tw-w-px tw-bg-iron-700 tw-mx-1 tw-flex-shrink-0" /></>;
    $[12] = isApp;
    $[13] = onViewChange;
    $[14] = router;
    $[15] = showStreamBack;
    $[16] = waveActive;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== onViewChange || $[19] !== showWavesTab || $[20] !== waveActive || $[21] !== wavesButtonClasses || $[22] !== wavesButtonTextClasses) {
    t10 = !waveActive && showWavesTab && <button ref={el => {
      tabRefs.current[BrainView.WAVES] = el;
    }} onClick={() => onViewChange(BrainView.WAVES)} className={wavesButtonClasses}><span className={wavesButtonTextClasses}>Waves</span></button>;
    $[18] = onViewChange;
    $[19] = showWavesTab;
    $[20] = waveActive;
    $[21] = wavesButtonClasses;
    $[22] = wavesButtonTextClasses;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== hasUnreadMessages || $[25] !== isApp || $[26] !== messagesButtonClasses || $[27] !== messagesButtonTextClasses || $[28] !== onViewChange || $[29] !== waveActive) {
    t11 = !isApp && !waveActive && <button ref={el_0 => {
      tabRefs.current[BrainView.MESSAGES] = el_0;
    }} onClick={() => onViewChange(BrainView.MESSAGES)} className={messagesButtonClasses}><span className={messagesButtonTextClasses}><span>Messages</span>{hasUnreadMessages && <div className="tw-absolute tw-rounded-full -tw-right-3 tw-top-0 tw-bg-red tw-h-2 tw-w-2" />}</span></button>;
    $[24] = hasUnreadMessages;
    $[25] = isApp;
    $[26] = messagesButtonClasses;
    $[27] = messagesButtonTextClasses;
    $[28] = onViewChange;
    $[29] = waveActive;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = el_1 => {
      tabRefs.current[BrainView.DEFAULT] = el_1;
    };
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  const t13 = waveActive ? "Chat" : "My Stream";
  let t14;
  if ($[32] !== chatButtonTextClasses || $[33] !== t13) {
    t14 = <span className={chatButtonTextClasses}>{t13}</span>;
    $[32] = chatButtonTextClasses;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== chatButtonClasses || $[36] !== onChatClick || $[37] !== t14) {
    t15 = <button ref={t12} onClick={onChatClick} className={chatButtonClasses}>{t14}</button>;
    $[35] = chatButtonClasses;
    $[36] = onChatClick;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== aboutButtonClasses || $[40] !== aboutButtonTextClasses || $[41] !== onViewChange || $[42] !== waveActive) {
    t16 = waveActive && <button ref={el_2 => {
      tabRefs.current[BrainView.ABOUT] = el_2;
    }} onClick={() => onViewChange(BrainView.ABOUT)} className={aboutButtonClasses}><span className={aboutButtonTextClasses}>About</span></button>;
    $[39] = aboutButtonClasses;
    $[40] = aboutButtonTextClasses;
    $[41] = onViewChange;
    $[42] = waveActive;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== activeView || $[45] !== isMemesWave || $[46] !== isRankWave || $[47] !== myVotesButtonClasses || $[48] !== myVotesButtonTextClasses || $[49] !== onViewChange || $[50] !== otucomeButtonTextClasses || $[51] !== outcomeButtonClasses || $[52] !== wave || $[53] !== waveActive) {
    t17 = waveActive && wave && isRankWave && <><MyStreamWaveTabsLeaderboard wave={wave} activeView={activeView} onViewChange={onViewChange} registerTabRef={(view, el_3) => {
        tabRefs.current[view] = el_3;
      }} />{isMemesWave && <><button ref={el_4 => {
          tabRefs.current[BrainView.MY_VOTES] = el_4;
        }} onClick={() => onViewChange(BrainView.MY_VOTES)} className={myVotesButtonClasses}><span className={myVotesButtonTextClasses}>My Votes</span></button></>}<button ref={el_5 => {
        tabRefs.current[BrainView.OUTCOME] = el_5;
      }} onClick={() => onViewChange(BrainView.OUTCOME)} className={outcomeButtonClasses}><span className={otucomeButtonTextClasses}>Outcome</span></button>{isMemesWave && <button ref={el_6 => {
        tabRefs.current[BrainView.FAQ] = el_6;
      }} onClick={() => onViewChange(BrainView.FAQ)} className={`tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-2 tw-py-1.5 tw-gap-1 tw-flex-1 tw-rounded-md ${activeView === BrainView.FAQ ? "tw-bg-iron-800" : "tw-bg-iron-950"}`}><span className={`tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap ${activeView === BrainView.FAQ ? "tw-text-iron-300" : "tw-text-iron-400"}`}>FAQ</span></button>}</>;
    $[44] = activeView;
    $[45] = isMemesWave;
    $[46] = isRankWave;
    $[47] = myVotesButtonClasses;
    $[48] = myVotesButtonTextClasses;
    $[49] = onViewChange;
    $[50] = otucomeButtonTextClasses;
    $[51] = outcomeButtonClasses;
    $[52] = wave;
    $[53] = waveActive;
    $[54] = t17;
  } else {
    t17 = $[54];
  }
  let t18;
  if ($[55] !== haveUnreadNotifications || $[56] !== isApp || $[57] !== notificationsButtonClasses || $[58] !== notificationsButtonTextClasses || $[59] !== onNotificationsClick || $[60] !== waveActive) {
    t18 = !isApp && !waveActive && <button ref={el_7 => {
      tabRefs.current[BrainView.NOTIFICATIONS] = el_7;
    }} onClick={onNotificationsClick} className={notificationsButtonClasses}><span className={notificationsButtonTextClasses}>Notifications{haveUnreadNotifications && <div className="tw-absolute tw-rounded-full -tw-right-1 -tw-top-1 tw-bg-red tw-h-2 tw-w-2" />}</span></button>;
    $[55] = haveUnreadNotifications;
    $[56] = isApp;
    $[57] = notificationsButtonClasses;
    $[58] = notificationsButtonTextClasses;
    $[59] = onNotificationsClick;
    $[60] = waveActive;
    $[61] = t18;
  } else {
    t18 = $[61];
  }
  let t19;
  if ($[62] !== t10 || $[63] !== t11 || $[64] !== t15 || $[65] !== t16 || $[66] !== t17 || $[67] !== t18 || $[68] !== t9) {
    t19 = <div className="tw-flex tw-justify-start tw-items-center tw-p-1 tw-gap-1 tw-w-full tw-overflow-x-auto tw-overflow-y-hidden tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 desktop-hover:hover:tw-scrollbar-thumb-iron-300 tw-py-1 tw-bg-iron-950 tw-border tw-border-solid tw-border-iron-800 tw-rounded-lg">{t9}{t10}{t11}{t15}{t16}{t17}{t18}</div>;
    $[62] = t10;
    $[63] = t11;
    $[64] = t15;
    $[65] = t16;
    $[66] = t17;
    $[67] = t18;
    $[68] = t9;
    $[69] = t19;
  } else {
    t19 = $[69];
  }
  let t20;
  if ($[70] !== setMobileTabsRef || $[71] !== t19) {
    t20 = <div ref={setMobileTabsRef} className="tw-py-2 tw-px-2 sm:tw-px-4 md:tw-px-6 tw-overflow-x-auto">{t19}</div>;
    $[70] = setMobileTabsRef;
    $[71] = t19;
    $[72] = t20;
  } else {
    t20 = $[72];
  }
  return t20;
};
export default BrainMobileTabs;